import Theme from "./theme";
import { Fonts, FontFamily } from "./fonts";
import colors from "./colors";
import Texts from "./texts";
const { spacing: Spacing } = Theme.dark;

export { Theme, Fonts, FontFamily, Texts, colors, Spacing }